import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { map, catchError, tap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { sortByName } from '@app/helpers/sorting.helpers';
import { MonthlyReportData } from '@app/models/row-data.interface';
import { ExportType } from '@app/shared/components/export-box/export-box.constants';
import { triggerFileDownload } from '@app/shared/functions';
import { EXPORT_PREFIX } from '@app/shared/constants/export-prefix';

import { ColumnLayout } from '../models/columns-layout';
import { MonthlyReportDOS } from './monthly-report-dos.service';
import { MonthlyReportRepoService } from './monthly-report-repo.service';

@Injectable({
  providedIn: 'root'
})
export class MonthlyReportService {
  constructor(
    private _monthlyReportRepoService: MonthlyReportRepoService,
    private _monthlyReportDOS: MonthlyReportDOS
  ) {}

  getAdminSettings(): Observable<ColumnLayout[]> {
    return this._monthlyReportRepoService.getAdminSettings().pipe(
      map((layout: ColumnLayout[]) => {
        layout.sort((a, b) => (a.position > b.position ? 1 : -1));
        return layout;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err);
      })
    );
  }

  getReportData(): Observable<MonthlyReportData[]> {
    const date = this._monthlyReportDOS.getMonthlyReportDateSnapshot();
    return this._monthlyReportRepoService.getReportData(date).pipe(
      map((data) => {
        return data.map((report) => {
          return { ...report, creativeHours: report.creativeHours || 0, totalHours: report.totalHours || 0 };
        });
      }),
      map((data) => data.sort((a, b) => sortByName(a, b)))
    );
  }

  exportReport(format: ExportType): Observable<HttpResponse<Blob>> {
    const currentDate = this._monthlyReportDOS.getMonthlyReportDateSnapshot();
    const [year, month] = [currentDate.getFullYear(), currentDate.getMonth()];
    const monthName = currentDate.toLocaleDateString('en', { month: 'long' });
    const correctedMonth = month + 1;
    const filename = `${EXPORT_PREFIX}_${monthName}_${year}.${format}`;

    return this._monthlyReportRepoService.exportReport(year, correctedMonth, filename, format).pipe(
      tap((response: HttpResponse<Blob>) => {
        triggerFileDownload(response.body, filename);
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err);
      })
    );
  }
}
